// This is the version of these messages
export const FABRIC_RPC_VERSION = "FabricMessageV3";
export var CosmosDbArtifactType;
(function (CosmosDbArtifactType) {
    CosmosDbArtifactType["MIRRORED_KEY"] = "MIRRORED_KEY";
    CosmosDbArtifactType["MIRRORED_AAD"] = "MIRRORED_AAD";
    CosmosDbArtifactType["NATIVE"] = "NATIVE";
})(CosmosDbArtifactType || (CosmosDbArtifactType = {}));
